<template>
  <div class="database">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="名称" label-width="40px">
        <el-input style="width: 140px" clearable v-model="searchForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
            v-model="searchForm.createStartTime"
            type="date"
            placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
            v-model="searchForm.createEndTime"
            type="date"
            placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="是否失效">
        <el-radio-group v-model="searchForm.expired">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button :label="true">是</el-radio-button>
          <el-radio-button :label="false">否</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="server"
            label="服务器IP">
        </el-table-column>
        <el-table-column
            prop="userId"
            label="用户名">
        </el-table-column>
        <el-table-column
            prop="dataBaseName"
            label="数据库名称">
        </el-table-column>
        <el-table-column
            prop="port"
            label="port"
            align="center">
        </el-table-column>
        <el-table-column
            prop="expireDate"
            label="失效日期"
            align="center">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="20%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="服务器IP">
          <el-select v-model="ruleForm.server" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据库名称">
          <el-input v-model="ruleForm.dataBaseName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="ruleForm.userId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="ruleForm.password" type="password"  placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="初始化">
          <el-radio-group v-model="ruleForm.autoInitDataBase">
            <el-radio-button :label="true">是</el-radio-button>
            <el-radio-button :label="false">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="端口号">
          <el-input v-model="ruleForm.port"  placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="失效时间">
        <el-date-picker
            style="width: 100%"
            v-model="searchForm.expireDate"
            type="date"
            placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  name: "database",
  data() {
    return {
      tableData: [],
      searchForm: {
        name: '',
        createStartTime: '',
        createEndTime: '',
        expired: '',
      },
      modelTitle: '新增数据库',
      dialogVisible: false,
      ruleForm: {
        server: '',
        dataBaseName: '',
        userId: '',
        password: '',
        autoInitDataBase:true,
        port: '',
        expireDate: null,
      },
      options:[],
      rules: {
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        name: '',
        code: '',
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    addItem() {
      this.modelTitle = '新增数据库'
      this.ruleForm = {
        server: '',
        userId: 'yh_administrator1',
        password: 'Yh88888888',
        dataBaseName: '',
        expireDate: null,
        autoInitDataBase:true,
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('数据库创建成功不可删除, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let data = {
              ...this.ruleForm,
              expireDate:this.ruleForm.expireDate
            }
            this.axios
                 .post("api/DataBaseManage?init="+ this.ruleForm.autoInitDataBase, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          return false;
        }
      });
    },
    deleteClick(id) {
      let data = {
        id: id
      }
      this.axios
           .delete("api/ServiceManage", {params: data}).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      }).finally(error => {
        this.init()
      })
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    // list
    init() {
      let data = {
        name: this.searchForm.name,
        createStartTime: this.searchForm.createStartTime,
        createEndTime: this.searchForm.createEndTime,
        expired: this.searchForm.expired,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/DataBaseManage", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.tableData.forEach(item => {
              switch (item.systemServiceType) {
                case 0:
                  item.systemServiceTypeName = '数据库服务器'
                  break;
                case 1:
                  item.systemServiceTypeName = 'Api服务器'
                  break;
                case 2:
                  item.systemServiceTypeName = '采集服务器'
                  break;
                case 3:
                  item.systemServiceTypeName = '数据缓存服务器'
                  break;
              }
            })
            this.total = res.count
          })
    },
    serverList(){
      let data={
        page:1,
        pageSize: 1000,
      }
      this.axios
          .get("api/ServiceManage", {params: data})
          .then((res) => {
            this.options = res.list
            let obj=[];
            this.options.forEach(item => {
              obj.push({
                value: item.ip,
                label: item.name,
              })
            });
            this.options =obj;
          })
    }
  },
  mounted() {
    //
    this.init()
    this.serverList()
  }
}
</script>

<style lang="scss" scoped>
.database {

}
</style>